import { paths } from '@/constants/paths'

interface CategoryTab {
  key: string
  labelKey: string
  defaultLabel: string
  href: string
  matchSlugs: string[]
}

export const WATCH_CATEGORY_TABS: CategoryTab[] = [
  { key: 'all', labelKey: 'tabAll', defaultLabel: 'All', href: paths.watch.index, matchSlugs: [] },
  { key: 'movies', labelKey: 'tabMovies', defaultLabel: 'Movies', href: paths.discover.movies, matchSlugs: ['movies'] },
  { key: 'series', labelKey: 'tabSeries', defaultLabel: 'Series', href: paths.discover.shows, matchSlugs: ['shows'] },
  { key: 'comedy', labelKey: 'tabComedy', defaultLabel: 'Comedy', href: paths.discover.comedy, matchSlugs: ['comedy'] },
  { key: 'free', labelKey: 'tabFree', defaultLabel: 'Free', href: paths.discover.free, matchSlugs: ['free'] },
  { key: 'family', labelKey: 'tabFamily', defaultLabel: 'Family', href: paths.discover.family, matchSlugs: ['family'] },
]

// Slugs that should show the category tabs on discover pages
export const DISCOVER_TABS_SLUGS = ['movies', 'shows', 'comedy', 'free', 'family'] as const
